/* Keep each collection page's return link tied to its own product section. */
if (!customElements.get('wonder-return-to-puzzles')) {
  customElements.define('wonder-return-to-puzzles', class extends HTMLElement {
    connectedCallback() {
      this.target = document.getElementById(this.getAttribute('target-id'));
      if (!this.target) return;
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.wrapper = this.closest('.page-wrapper');
      this.update = () => {
        this.frame = 0;
        this.hidden = this.target.getBoundingClientRect().bottom > this.headerOffset();
      };
      this.schedule = () => {
        if (!this.frame) this.frame = requestAnimationFrame(this.update);
      };
      window.addEventListener('scroll', this.schedule, { passive: true, signal });
      this.wrapper?.addEventListener('scroll', this.schedule, { passive: true, signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal });
      window.addEventListener('pageshow', this.schedule, { signal });
      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(document.getElementById('MainContent') || this.target);
      this.addEventListener('click', event => {
        if (!event.target.closest('a') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        const heading = this.target.querySelector('h2') || this.target;
        // Horizon scrolls .page-wrapper on desktop and the document on mobile.
        const scroller = this.wrapper && /auto|scroll/.test(getComputedStyle(this.wrapper).overflowY) ? this.wrapper : window;
        const scrollTop = scroller === window ? window.scrollY : scroller.scrollTop;
        const top = this.target.getBoundingClientRect().top + scrollTop - this.headerOffset(true) - 16;
        heading.setAttribute('tabindex', '-1');
        heading.focus({ preventScroll: true });
        scroller.scrollTo({ top: Math.max(0, top), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, { signal });
      this.update();
    }

    headerOffset(returning = false) {
      // Covers both the general sticky header and Shopify's Christmas header.
      const stickyHeight = returning ? document.querySelector('#header-component[sticky]')?.getBoundingClientRect().height || 0 : 0;
      return [...document.querySelectorAll('#header-group, #header-group .header-section')].reduce((bottom, element) => {
        const position = getComputedStyle(element).position;
        if (position !== 'sticky' && position !== 'fixed') return bottom;
        const rect = element.getBoundingClientRect();
        return rect.top <= 1 && rect.bottom > 0 && rect.height < window.innerHeight / 2 ? Math.max(bottom, rect.bottom) : bottom;
      }, stickyHeight);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
